/**
 * 负责载入各个模块对应的model，启动concent的脚本
 */
import { run } from 'concent';
import loadingPlugin from 'concent-plugin-loading';
import { message } from 'antd';

import * as models from '../models';

const store = Object.keys(models).reduce((store, moduleName) => {
  console.log(` ****** load module[${moduleName}]`);
  const storeEl = store;
  (storeEl as any)[moduleName] = (models as any)[moduleName];
  return store;
}, {});

run(store, {
  errorHandler: (err) => {
    console.error(err);
    message.error(err.message);
  },
  plugins: [loadingPlugin],
  middlewares: [
    (info, next) => {
      next();
    },
  ],
});
